import { render, staticRenderFns } from "./refundDetail.vue?vue&type=template&id=052a44bf&scoped=true&"
import script from "./refundDetail.vue?vue&type=script&lang=js&"
export * from "./refundDetail.vue?vue&type=script&lang=js&"
import style0 from "./refundDetail.vue?vue&type=style&index=0&id=052a44bf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a44bf",
  null
  
)

export default component.exports